module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "heading"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALSO BY"), _c('br'), _vm._v("JANE GARDAM")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICTION")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "https://www.europaeditions.com/book/9781609451417/a-long-way-from-verona",
      "target": "_blank"
    }
  }, [_vm._v("A Long Way From Verona")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Summer After the Funeral")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "https://www.europaeditions.com/book/9781609453312/bilgewater",
      "target": "_blank"
    }
  }, [_vm._v("Bilgewater")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Black Faces, White Faces")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "https://www.europaeditions.com/book/9781933372761/god-on-the-rocks",
      "target": "_blank"
    }
  }, [_vm._v("God on the Rocks")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Sidmouth Letters")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Pangs of Love and Other Stories")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "https://www.europaeditions.com/book/9781609450694/crusoe-s-daughter",
      "target": "_blank"
    }
  }, [_vm._v("Crusoe’s Daughter")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Showing the Flag")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "https://www.europaeditions.com/book/9781933372365/the-queen-of-the-tambourine",
      "target": "_blank"
    }
  }, [_vm._v("The Queen of the Tambourine")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Missing the Midnight")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "https://www.europaeditions.com/book/9781609454050/the-flight-of-the-maidens",
      "target": "_blank"
    }
  }, [_vm._v("The Flight of the Maidens")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "https://www.europaeditions.com/book/9781933372136/old-filth",
      "target": "_blank"
    }
  }, [_vm._v("Old Filth")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "https://www.europaeditions.com/book/9781933372563/the-people-on-privilege-hill",
      "target": "_blank"
    }
  }, [_vm._v("The People on Privilege Hill")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "https://www.europaeditions.com/book/9781933372891/the-man-in-the-wooden-hat",
      "target": "_blank"
    }
  }, [_vm._v("The Man in the Wooden Hat")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "https://www.europaeditions.com/book/9781609450939/last-friends",
      "target": "_blank"
    }
  }, [_vm._v("Last Friends")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "https://www.europaeditions.com/book/9781609453442/the-stories-of-jane-gardam",
      "target": "_blank"
    }
  }, [_vm._v("The Stories")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OR CHILDREN")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bridget and William")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "https://www.europaeditions.com/book/9781609452469/the-hollow-land",
      "target": "_blank"
    }
  }, [_vm._v("The Hollow Land")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A Fair Few Days")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONFICTION")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Iron Coast")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LLUSTRATED")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Green Man")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8286520","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/faith-fox_00000.vue
// module id = 60
// module chunks = 0